/**
 * v1.2 Part 1 Branding: Presentation Mode premium tier badges.
 *
 * Maps a subset of nav items to a "Professional" or "Elite" tier so
 * prospects exploring the Showcase Edition (/demo) can see which
 * capabilities are part of higher-tier packages. Shown ONLY for demo
 * users — real customers never see these on their own nav.
 */
export const PREMIUM_FEATURE_TIERS = {
  Reports: "elite",
  Announcements: "professional",
  Expenses: "professional",
  "Vehicle Issues": "professional",
  // v1.4 815 Digital Services rebrand: tier signaling now also shows up
  // directly on the modules themselves (BusinessPulse.js, DailyBriefCard.js,
  // InsightsRecommendationsFeed.js, CommunicationCenter.js,
  // DriveDeskAIWidget.js, ActionPlanMessageCard.js) rather than only here —
  // these keys stay in one place so the Pro/Elite story is consistent
  // everywhere it's referenced.
  "Business Pulse": "professional",
  "Daily Brief": "professional",
  "Communication Center": "professional",
  "Insights & Recommendations": "elite",
  "Your AI Office Manager": "elite",
  "AI Action Plans": "elite",
};
